import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { CreditAccountView } from "./CreditAccountView";
import { CreditAccountViewStore } from "../../store/CreditAccountViewStore";
import { useStore } from "../../../../hooks";

export const CreditAccountViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/creditAccount/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new CreditAccountViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <CreditAccountView creditAccountViewStore={store} />
      </PageLayout>
    </div>
  );
});
